import React from 'react';
import { InfoWindow } from '@react-google-maps/api';
import Rating from '@mui/material/Rating';
import { getSpeedWithUnit, trimPhone } from '../helpers/untils';
import { DEVICE_TYPE, INSTALLER_TRACKER_TYPE, MACHINE_ENVIRONMENT } from '../config/constant';
import { formatDate, formatPosition } from '../common/formatter';
import GoogleGeolocationAddressBox from '../components/GoogleGeolocationAddressBox';
import moment from 'moment';
import { Stack } from '@mui/material';
import { useTranslation } from '../LocalizationProvider';
import GoogleDrivenTimeBox from '../components/GoogleDrivenTimeBox';

const DeviceInfoWindow = (props) => {
  const {
    position,
    marker,
    setCurrentMarker,
    currentDeviceData,
    open,
    setOpen,
    currentPosition = {},
    deviceList = [],
    shuttleInfo = {}
  } = props

  const t = useTranslation();

  const device = deviceList.find((item) => item.id === Number(currentDeviceData.id)) || currentDeviceData

  const handleInfoWindowClose = () => {
    // setOpen(false);
    setCurrentMarker(null);
  }

  return (
    <>
      <InfoWindow
        position={position ?? marker?.position}
        onCloseClick={handleInfoWindowClose}
      >
        <Stack direction={`column`} spacing={1.5} style={{ width: '250px', paddingBottom: '16px', fontWeight: '500', fontSize: '16px' }}>
          <div>
            <p><span style={{ fontWeight: 'bold' }}>{device?.name}</span></p>
          </div>
          <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={2}>
            <p><span>Last Position</span></p>
            <p style={{ textAlign: 'right' }}><span>{formatDate(device.lastPosition)}</span></p>
          </Stack>
          <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={2}>
            <p>
              <GoogleGeolocationAddressBox
                lat={device.latitude}
                lng={device.longitude}
                autoShow={true}
                facility={shuttleInfo}
              />
            </p>
            <p style={{ textAlign: 'right' }}>
              <GoogleDrivenTimeBox
                lat={device.latitude}
                lng={device.longitude}
                destinationsLocation={currentPosition}
                autoShow={true}
                facility={shuttleInfo}
              />
            </p>
          </Stack>
          <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={2}>
            <p><span>Speed</span></p>
            <p style={{ textAlign: 'right' }}>
              <span>
                <>
                  {
                    (device.deviceType === DEVICE_TYPE.SMARTCAR || device.deviceType === DEVICE_TYPE.TESLA) ? (
                      <>
                        {getSpeedWithUnit(device.speed, device.distance_unit)}
                      </>
                    ) : (
                      <>
                        {
                          (moment().diff(moment(device.lastPosition), "seconds") < 5 * 60 || MACHINE_ENVIRONMENT === 'dev') ? (
                            <>
                              {getSpeedWithUnit(device.speed, device.distance_unit)}
                            </>
                          ) : (
                            <>
                              {getSpeedWithUnit(0, device.distance_unit)}
                            </>
                          )
                        }
                      </>
                    )
                  }
                </>
              </span>
            </p>
          </Stack>
          <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={2}>
            <p><span>Direction</span></p>
            <p style={{ textAlign: 'right' }}>
              <span>
                {formatPosition(device.direction, 'direction', t)}
              </span>
            </p>
          </Stack>
        </Stack>
      </InfoWindow>
    </>
  );
}

export default DeviceInfoWindow;
